import styled from 'styled-components';

interface ChatBotProps {
  readonly suggestions?: any;
  readonly isOpen?: boolean;
}

export const TextLoading = styled.img`
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

export const ChatBotWrapper = styled.div<ChatBotProps>`
  z-index: 2;
  position: relative;
  font-family: 'Roboto', sans-serif !important;

  .sc-launcher {
    bottom: 10px;
    right: 10px;
  }

  .sc-launcher .sc-open-icon,
  .sc-launcher .sc-closed-icon {
    bottom: 10px;
    right: 10px;
  }

  .sc-header {
    padding: 0;
    background: linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(254, 166, 40, 1) 0%, rgba(246, 196, 27, 1) 100%);
    min-height: 0px;
    position: relative;
  }

  .sc-header--close-button {
    background-color: transparent;
  }

  .sc-header--team-name {
    font-weight: 700;
    font-size: 20px;
  }

  /* Inject controls into header using CSS */
  .sc-header::after {
    content: '';
    position: absolute;
    top: 8px;
    right: 40px;
    width: 80px;
    height: 20px;
    pointer-events: none;
  }

  .header-controls {
    position: absolute;
    top: 8px;
    right: 40px;
    display: flex;
    gap: 8px;
    align-items: center;
    z-index: 10;
  }

  .header-control-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
    color: white;
    font-size: 11px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }

  .header-control-toggle {
    display: flex;
    align-items: center;
    gap: 4px;
    color: white;
    font-size: 11px;
  }

  .header-control-toggle input {
    margin: 0;
    width: 12px;
    height: 12px;
  }

  .sc-message--text {
    padding: 6px 10px;
    font-weight: normal;
    width: fit-content !important;
    max-width: 280px;
    word-wrap: break-word;
    border-radius: 20px;
  }

  .sc-message--content.sent .sc-message--text {
    background: linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(254, 166, 40, 1) 0%, rgba(246, 196, 27, 1) 100%);
  }

  .sc-chat-window {
    font-family: inherit;
    bottom: 80px;
    width: 400px !important;
    max-width: 90vw;
  }

  .sc-message {
    width: 100%;
    max-width: 380px;
  }

  .sc-message-list {
    padding: 10px 0;
    width: 100%;
  }

  .sc-message--avatar {
    background-image: url('/logo.svg') !important;
    background-size: contain;
  }
  .sc-message:last-child {
    margin-bottom: ${(props) => (props.suggestions ? `calc(${props.suggestions} * 32px)` : '0px')};
  }

  .sc-user-input--file-icon-wrapper {
    display: none;
  }

  .detail {
    font-weight: bold;
  }

  .sc-message-list,
  .sc-user-input {
    ::-webkit-scrollbar {
      width: 10px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #ccc;
      border: none;
      outline: none;
    }
  }

  .sc-user-input--button {
    align-self: center;
  }

  .sc-user-input--text {
    color: #333 !important;
  }

  .sc-user-input--text::placeholder {
    color: #999 !important;
  }

  div[role='button'] {
    ::-webkit-scrollbar {
      width: 10px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #ccc;
      border: none;
      outline: none;
    }
  }
`;

export const SuggestionWrapper = styled.div<ChatBotProps>`
  position: fixed;
  bottom: 140px;
  right: 35px;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  font-size: 14px;
  gap: 4px;
  max-width: 350px;

  .tag-suggestion {
    padding: 4px 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 320px;
    border-radius: 28px;
    cursor: pointer;
    background-color: white;
  }
`;

export const SessionTitleDialog = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  min-width: 300px;
`;

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const DialogTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
`;

export const DialogInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 16px;

  &:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

export const DialogButtons = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const DialogButton = styled.button<{ primary?: boolean }>`
  padding: 6px 16px;
  border: 1px solid ${(props) => (props.primary ? '#1890ff' : '#d9d9d9')};
  border-radius: 4px;
  background: ${(props) => (props.primary ? '#1890ff' : 'white')};
  color: ${(props) => (props.primary ? 'white' : '#666')};
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: ${(props) => (props.primary ? '#40a9ff' : '#f5f5f5')};
  }
`;

export const ClickableTitle = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    opacity: 0.8;
  }

  .edit-icon {
    font-size: 12px;
    opacity: 0.6;
  }
`;

export const ControlsContainer = styled.div`
  position: fixed;
  bottom: 10px;
  right: 80px;
  display: flex;
  gap: 12px;
  align-items: center;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const ControlButton = styled.button`
  background: #ff4d4f;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  color: white;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #ff7875;
  }
`;

export const ControlToggle = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #333;
  font-size: 12px;
  cursor: pointer;

  input {
    margin: 0;
    width: 14px;
    height: 14px;
  }
`;
